<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import { definePage } from "unplugin-vue-router/runtime";
import InviteRecipientRegisterForm from "@/components/models/invite/InviteRecipientRegisterForm.vue";

definePage({
  meta: {
    title: "models.invitations.acceptInvitation",
    requiresAuth: false,
    layout: "public",
  },
});

const route = useRoute();

const recipientId = computed(() => ("id" in route.params ? String(route.params.id) : ""));
</script>

<template>
  <invite-recipient-register-form
    v-if="recipientId"
    :recipient-id="recipientId"
  />
</template>
